export const MetricTile = ({ label, v1, v2, suffix = "", higherIsBetter = true, name1, name2, icon }) => {
  const a = parseFloat(v1) || 0;
  const b = parseFloat(v2) || 0;
  let winner = null;
  if (a !== b) winner = higherIsBetter ? (a > b ? "a" : "b") : (a < b ? "a" : "b");

  const winnerClass = "text-emerald-400 drop-shadow-[0_0_8px_rgba(16,185,129,0.3)]";

  return (
    <div
      className="bg-gradient-to-b from-white/[0.05] to-white/[0.01] border border-white/[0.07] rounded-xl p-4 hover:border-white/[0.15] transition-all group"
      data-testid={`metric-${label.toLowerCase().replace(/\s/g, "-")}`}
    >
      <div className="text-[10px] text-slate-400 uppercase tracking-wider mb-3 font-semibold flex items-center gap-1.5">
        {icon}
        {label}
      </div>
      <div className="flex items-end justify-between gap-2">
        <div className="text-center flex-1">
          <div className={`text-2xl font-black tabular-nums ${winner === "a" ? winnerClass : "text-slate-200"}`}>
            {v1}{suffix}
          </div>
          <div className="text-[10px] text-slate-400 mt-1 truncate font-medium">{name1}</div>
        </div>
        <div className="text-[10px] text-slate-500 font-bold pb-1.5">vs</div>
        <div className="text-center flex-1">
          <div className={`text-2xl font-black tabular-nums ${winner === "b" ? winnerClass : "text-slate-200"}`}>
            {v2}{suffix}
          </div>
          <div className="text-[10px] text-slate-400 mt-1 truncate font-medium">{name2}</div>
        </div>
      </div>
    </div>
  );
};

export default MetricTile;
